// blog18.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg"; // hero background
import detailImg from "../Asets/blog1818.png"; // detail image (keep or replace as needed)
import Header from "../components/header";
import Footer from "../components/footer";

const Blog18 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Red School House Vadodara</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span> / Our Blog / Red School House Vadodara</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Red School House Vadodara – Creating a Joyful Start to Every Child’s
            Learning Journey
          </h2>
          <br />
          <div className="published-badge">Published on: 5 November 2025</div>
          <br />

          <img
            src={detailImg}
            alt="Red School House Vadodara - Play based learning and preschool"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              Every child’s first steps into learning should be filled with joy,
              curiosity, and care. At <strong>Red School House Vadodara</strong>,
              we believe education is more than textbooks — it’s about creating
              a nurturing environment where children love to learn, explore,
              and grow. With our play-based approach, every day is turned into
              a meaningful adventure that builds strong foundations for lifelong
              success.
            </p>

            <h3>A School Where Learning Feels Like Play</h3>
            <p>
              Children learn best when they are happy — that’s the philosophy
              behind Red School House Vadodara. Our classrooms are bright,
              engaging, and stocked with hands-on learning materials. Through
              activities like storytelling, art, music, and guided group play,
              children develop essential skills such as communication,
              creativity, and problem-solving — all while having fun.
            </p>

            <h3>Experienced Teachers Who Care Like Family</h3>
            <p>
              Our teachers are more than instructors — they are mentors and
              caregivers who focus on each child’s emotional, social, and
              cognitive growth. Small class sizes allow for personalised
              attention, helping children build confidence and a sense of
              belonging in a warm, family-like atmosphere.
            </p>

            <h3>Building Strong Foundations for the Future</h3>
            <p>
              Our preschool curriculum is designed to nurture well-rounded
              development. We focus on:
            </p>
            <ul>
              <li>
                <strong>Language & Communication:</strong> Stories, group
                discussions and interactive activities that boost vocabulary
                and expression.
              </li>
              <li>
                <strong>Motor Skills:</strong> Art, dance and outdoor play to
                enhance coordination and physical confidence.
              </li>
              <li>
                <strong>Social & Emotional Growth:</strong> Team activities and
                guided play that teach empathy, sharing, and cooperation.
              </li>
              <li>
                <strong>Cognitive Development:</strong> Puzzles, exploratory
                play and structured tasks that encourage reasoning and
                curiosity.
              </li>
            </ul>

            <h3>Why Parents Choose Red School House Vadodara</h3>
            <p>
              Parents trust Red School House because we combine modern early
              childhood education practices with warm, family-centered care.
              Key reasons families choose us:
            </p>
            <ul>
              <li>Safe, child-friendly campus and facilities.</li>
              <li>Play-based, activity-oriented curriculum.</li>
              <li>Experienced and compassionate teachers.</li>
              <li>Regular parent communications and progress updates.</li>
              <li>Affordable fees with a strong focus on value and outcomes.</li>
              <li>Emphasis on holistic development — academic, social and
                  emotional.</li>
            </ul>

            <h3>Admissions & Enrolment</h3>
            <p>
              We welcome families to visit the school and experience our
              learning environment firsthand. Our admission process is simple
              and parent-friendly — focused on finding the right fit for each
              child’s needs. Contact us to schedule a visit or to learn more
              about seat availability and fees.
            </p>

            <h3>Location & Contact Details</h3>
            <p>
              <strong>Red School House Vadodara</strong>
              <br />
              📍 Address: A-25, Castle White, Opp. Main Harni Water Tank, Harni
              Sama Link Road, Vadodara – 390008
              <br />
              📞 Phone: <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              📧 Email:{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">
                redschoolhousebaroda2025@gmail.com
              </a>{" "}
              |{" "}
              <a href="mailto:redschoolhousebaroda@gmail.com">
                redschoolhousebaroda@gmail.com
              </a>
              <br />
              🌐 Website:{" "}
              <a
                href="https://redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                redhouseschoolvadodara.in
              </a>
            </p>

            <h3>Conclusion</h3>
            <p>
              Your child’s early years lay the groundwork for future learning.
              At Red School House Vadodara, we make those years joyful,
              meaningful, and full of discovery. From the moment they walk into
              our classrooms, children begin a journey that nurtures both heart
              and mind — shaping them into confident, curious, and compassionate
              individuals. Enrol today and let your child experience the joy of
              learning at one of Vadodara’s most loved preschools.
            </p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog18;
